export function normalizeAirportText(value) {
  return String(value == null ? "" : value)
    .toLowerCase()
    .replace(/[.\s]+/g, "");
}

export function isAllAirports(location) {
  return Boolean(
    location &&
      location.airportName &&
      location.airportName.toLowerCase().includes("all")
  );
}

export function formatAirportTitle(location) {
  if (!location || !location.airportName) {
    return "";
  }
  if (isAllAirports(location)) {
    return location.airportName;
  }
  return location.airportName
    .replace(/\./g, " ")
    .replace(/\s+/g, " ")
    .replace(/ International Airport$/i, " International")
    .trim();
}

export function formatAirportLabel(location) {
  if (! location || ! location.airportName) {
    return "";
  }
  if (isAllAirports(location)) {
    return location.airportName;
  }
  return `${location.city} - ${location.airportName}`;
}

function aliases(location) {
  return (location.searchable || []).map(normalizeAirportText);
}

function hasExactAlias(location, normalizedQuery) {
  return aliases(location).includes(normalizedQuery);
}

function fields(location) {
  return [
    location.airportCode,
    location.airportName,
    location.city,
    location.country,
    ...(location.searchable || [])
  ];
}

function fieldIncludes(location, normalizedQuery) {
  return fields(location).some(field =>
    normalizeAirportText(field).includes(normalizedQuery)
  );
}

function matchesQuery(location, normalizedQuery) {
  const parts = normalizedQuery
    .split(",")
    .map(part => part.trim())
    .filter(Boolean);
  if (parts.length > 1) {
    return parts.every(part => fieldIncludes(location, part));
  }
  return fieldIncludes(location, normalizedQuery);
}

function sortAirports(matches, normalizedQuery) {
  return [...matches].sort((airportA, airportB) => {
    const aliasDelta =
      Number(hasExactAlias(airportB, normalizedQuery)) -
      Number(hasExactAlias(airportA, normalizedQuery));
    if (aliasDelta) {
      return aliasDelta;
    }
    const codeDelta =
      Number(normalizeAirportText(airportB.airportCode) === normalizedQuery) -
      Number(normalizeAirportText(airportA.airportCode) === normalizedQuery);
    if (codeDelta) {
      return codeDelta;
    }
    return (airportB.weight || 0) - (airportA.weight || 0);
  });
}

export function filterAirports(airports, query) {
  const normalizedQuery = normalizeAirportText(query);
  if (!normalizedQuery) {
    return [];
  }

  const aliasMatches = airports.filter(location =>
    hasExactAlias(location, normalizedQuery)
  );
  if (normalizedQuery.length < 3 && aliasMatches.length) {
    return sortAirports(aliasMatches, normalizedQuery);
  }

  return sortAirports(
    airports.filter(location => matchesQuery(location, normalizedQuery)),
    normalizedQuery
  );
}
